<div class="fx-row justify-content-start align-items-center">
  <div class="input-wrapper" *ngFor="let input of inputs" [class]="{'focus':input.focus,'error':input.error}">
    <input type="text" [id]="'input-'+input.id" [placeholder]="placeholder" [(ngModel)]="input.value"
      (ngModelChange)="onModelChange(input,$event)" (focus)="input.focus = true" (blur)="input.focus = false;"
      maxlength="1" />
  </div>
</div>